<template>
  <div>
    <el-form :inline="true" :model="filters" size="small">
      <el-form-item>
        <el-input
          class="filter-input"
          prefix-icon="el-icon-search"
          v-model="filters.nameOrMobile"
          placeholder="接收人名/手机号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click.native="initData"></butn>
        <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      filters: {}
    };
  },

  methods: {
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", {});
    }
  }
};
</script>

<style scoped>
.filter-input {
  width: 220px;
}
</style>
